module.exports = require('./lib/client/index');



//////////////////
// WEBPACK FOOTER
// ./~/feathers-rest/client.js
// module id = 247
// module chunks = 0